import React from 'react';

export default function NewsPageHero({
  eyebrow,
  title,
  subtitle,
  description,
  children,
  variant = 'index',
}) {
  const isArticle = variant === 'article';

  return (
    <section className="about-section-bg relative overflow-hidden border-b border-border bg-secondary/60">
      <div
        className="absolute -right-24 -top-32 h-80 w-80 rounded-full bg-primary-50 blur-3xl"
        aria-hidden="true"
      />
      <div
        className={`container relative ${
          isArticle ? 'py-12 md:py-16' : 'py-16 md:py-24'
        }`}
      >
        {eyebrow && (
          <p className="font-heading text-sm font-semibold uppercase tracking-eyebrow-wide text-primary">
            {eyebrow}
          </p>
        )}
        <h1
          className={`${eyebrow ? 'mt-3' : ''} max-w-5xl text-pretty font-heading font-bold [overflow-wrap:anywhere] ${
            isArticle
              ? 'tracking-[0.01em] text-foreground text-[1.375rem] leading-[1.6] sm:text-3xl lg:text-[2rem] lg:leading-[1.55]'
              : 'gradient-text text-3xl leading-[1.3] tracking-[0.02em] md:text-4xl'
          }`}
        >
          {title}
        </h1>
        {subtitle && (
          <p className="mt-4 text-lg text-muted-foreground sm:text-xl">
            {subtitle}
          </p>
        )}
        {description && (
          <p className="mt-5 max-w-3xl text-base leading-loose text-muted-foreground sm:text-lg">
            {description}
          </p>
        )}
        {children}
      </div>
    </section>
  );
}
